import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=458c31b2&scoped=true&"
import script from "./OrderList.vue?vue&type=script&lang=js&"
export * from "./OrderList.vue?vue&type=script&lang=js&"
import style0 from "./OrderList.vue?vue&type=style&index=0&id=458c31b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458c31b2",
  null
  
)

export default component.exports